import IcomoonReact from 'icomoon-react';
import iconSet from './selection.json';
import PropTypes from 'prop-types';

export const IconMoon = ({ color, size, icon, className }) => {
  return (
    <IcomoonReact
      className={className}
      iconSet={iconSet}
      color={color}
      size={size}
      icon={icon}
    />
  );
};

IconMoon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
};

IconMoon.defaultProps = {
  color: '#444',
  size: '1.5rem',
};
